<template>
	<div class="order">
		<el-tabs v-model="activeName">
			<el-tab-pane label="订单总览" name="extract"></el-tab-pane>
			<el-tab-pane label="手动发货(取回)" name="manual"></el-tab-pane>
			<el-tab-pane label="机器人发货(取回)" name="robot"></el-tab-pane>
			<el-tab-pane label="扎比特发货(取回)" name="zbt_delivery"></el-tab-pane>
		</el-tabs>
		<Extract v-if="activeName === 'extract'"></Extract>
		<Manual v-if="activeName === 'manual'"></Manual>
		<Robot v-if="activeName === 'robot'"></Robot>
		<ZbtDelivery v-if="activeName === 'zbt_delivery'"></ZbtDelivery>
	</div>
</template>
<script>
	import Extract from './Extract'
	import Manual from './Manual'
	import Robot from './Robot'
	import ZbtDelivery from './ZbtDelivery'

	export default {
		components: {
			Extract,
			Manual,
			Robot,
			ZbtDelivery
		},
		data() {
			return {
				activeName: 'extract'
			}
		}
	}
</script>

<style>
</style>
